import { options_junkEmail_safeMailingLists } from 'owa-locstrings/lib/strings/options_junkemail_safemailinglists.locstring.json';
import { options_junkEmail_safeSenders } from 'owa-locstrings/lib/strings/options_junkemail_safesenders.locstring.json';
import { options_dynamicEmail_allowedSendersList } from 'owa-locstrings/lib/strings/options_dynamicemail_allowedsenderslist.locstring.json';
import {
    optionPlaceHolder_blockSenderDomain,
    optionPlaceholder_safeSenderDomain,
    optionPlaceholder_safeMailingList,
    options_junk_blockedSenderDomainDescription,
    optionPlaceHolder_allowedDynamicEmailSender,
} from './getSpamStrings.locstring.json';
import loc from 'owa-localize';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { assertNever } from 'owa-assert';

// Used to retrieve text placeholder given scenarioId
export function getSpamPlaceHolder(scenarioId: SpamScenarioId): string {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return loc(optionPlaceHolder_blockSenderDomain);
        case SpamScenarioId.SafeSendersAndDomains:
            return loc(optionPlaceholder_safeSenderDomain);
        case SpamScenarioId.SafeMailingLists:
            return loc(optionPlaceholder_safeMailingList);
        case SpamScenarioId.AllowedDynamicEmailSenders:
            return loc(optionPlaceHolder_allowedDynamicEmailSender);
        default:
            return assertNever(scenarioId);
    }
}

// Used to retrieve option description given scenarioId
export function getSpamDescription(scenarioId: SpamScenarioId): string {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return loc(options_junk_blockedSenderDomainDescription);
        case SpamScenarioId.SafeSendersAndDomains:
            return loc(options_junkEmail_safeSenders);
        case SpamScenarioId.SafeMailingLists:
            return loc(options_junkEmail_safeMailingLists);
        case SpamScenarioId.AllowedDynamicEmailSenders:
            return loc(options_dynamicEmail_allowedSendersList);
        default:
            return assertNever(scenarioId);
    }
}
